import * as React from "react";

import { OpsGenieIcon } from "./Components/OpsGenieIcon/OpsGenieIcon";
import { TeamAppConfig } from "Apps/TeamAppModel";

const OpsGenieApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "OpsGenie" */ "./OpsGenieApp");
    return { default: namedExport.OpsGenieApp };
});

export const OpsGenie: TeamAppConfig = {
    title: "OpsGenie Copilot",
    regularIcon: OpsGenieIcon,
    filledIcon: OpsGenieIcon,
    description: "OpsGenie - Copilot of M365 Pulse",
    team: "OpsGenie",
    publicId: "ExchangeOSP",
    owner: "OpsGenieFeedback@microsoft.com",
    role: "*",
    tags: [],
    app: OpsGenieApp,
    path: "/OpsGenie"
};
